import { render, staticRenderFns } from "./ProjectsGrid.vue?vue&type=template&id=307dba40&scoped=true&"
import script from "./ProjectsGrid.vue?vue&type=script&lang=js&"
export * from "./ProjectsGrid.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsGrid.vue?vue&type=style&index=0&id=307dba40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "307dba40",
  null
  
)

export default component.exports